document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger, SplitText);

  // ─── INIZIALIZZAZIONE: Solo se esistono elementi [data-animate] ─────────────
  const dataAnimateElements = document.querySelectorAll('[data-animate]');
  if (dataAnimateElements.length > 0) {
    gsap.set('[data-animate]', { opacity: 0 });
    gsap.to('[data-animate]', {
      opacity: 1,
      delay: 0.3,
      duration: 1
    });
  }

  // ─── HERO ────────────────────────────────────────────────────────────────────
  const heroTitles = document.querySelectorAll('.hero__title');
  heroTitles.forEach((heroTitle) => {
    const section = heroTitle.closest('section, .shopify-section, .hero');

    const heroTl = gsap.timeline({
      defaults: { ease: 'power3.out' },
      scrollTrigger: {
        trigger: heroTitle,
        start: 'top 85%',
        once: true,
      }
    });

    heroTl.from(heroTitle, {
      y: 60,
      opacity: 0,
      duration: 1,
    });

    const heroSubtitle = section?.querySelector('.hero__subtitle, .hero__description');
    if (heroSubtitle) {
      heroTl.from(heroSubtitle, {
        y: 40,
        opacity: 0,
        duration: 0.8,
        stagger: 0.15,
      }, '-=0.5');
    }

    const heroCta = section?.querySelector('.hero__cta, .hero__buttons a');
    if (heroCta) {
      heroTl.from(heroCta, {
        y: 20,
        opacity: 0,
        duration: 0.6,
        stagger: 0.1,
      }, '-=0.4');
    }
  });

  // ─── PARALLAX: Solo su hero ──────────────────────────────────────────────────
  const parallaxImages = document.querySelectorAll('.hero__media-wrapper img, .parallax img, .background-image-container img');
  if (parallaxImages.length > 0) {
    parallaxImages.forEach((img) => {
      gsap.set(img, { scale: 1.2 });

      ScrollTrigger.create({
        trigger: img.parentElement,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        onEnter: () => gsap.set(img, { willChange: 'transform' }),
        onLeave: () => gsap.set(img, { willChange: 'auto' }),
        onEnterBack: () => gsap.set(img, { willChange: 'transform' }),
        onLeaveBack: () => gsap.set(img, { willChange: 'auto' }),
        animation: gsap.fromTo(img, { y: '8%' }, { y: '-8%', ease: 'none' })
      });
    });
  }

  // ─── STAGGER: Griglie ────────────────────────────────────────────────────────
  const grids = document.querySelectorAll('.resource-list--grid');
  if (grids.length > 0) {
    grids.forEach((grid) => {
      const children = grid.children;
      if (children.length > 0) {
        gsap.from(children, {
          scrollTrigger: {
            trigger: grid,
            start: 'top 85%',
            once: true,
          },
          y: 50,
          opacity: 0,
          duration: 0.7,
          stagger: 0.1,
          ease: 'power2.out',
        });
      }
    });
  }

  // ─── STAGGER: Sezioni fourcol ────────────────────────────────────────────────
  const fourcols = document.querySelectorAll('.fourcol, .threecol , .twocol');
  if (fourcols.length > 0) {
    fourcols.forEach((section) => {
      const columns = section.querySelectorAll(':scope .section-content-wrapper > .group-block');
      if (columns.length > 0) {
        gsap.from(columns, {
          scrollTrigger: {
            trigger: section,
            start: 'top 85%',
            once: true,
          },
          y: 50,
          opacity: 0,
          duration: 0.7,
          stagger: 0.15,
          ease: 'power2.out',
        });
      }
    });
  }

  // ─── SPLIT TEXT ──────────────────────────────────────────────────────────────
  const splitElements = document.querySelectorAll(".split-animation");
  if (splitElements.length > 0) {
    gsap.set(".split-animation", { opacity: 1 });

    splitElements.forEach((element) => {
      SplitText.create(element, {
        type: "words",
        autoSplit: true,
        onSplit: (self) => {
          gsap.from(self.words, {
            duration: 0.6,
            yPercent: 20,
            opacity: 0,
            stagger: 0.08,
            ease: "expo.out",
            scrollTrigger: {
              trigger: element,
              start: "top 80%",
              once: true,
            }
          });
        }
      });
    });
  }

  // ─── Refresh ─────────────────────────────────────────────────────────────────
  window.addEventListener('load', () => ScrollTrigger.refresh());
});